module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "checklist"
    }
  }, [_c('h2', [_vm._v("Shrnutí")]), _vm._v(" "), _c('ul', {
    staticClass: "checklist-items"
  }, [_c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.jmeno.valid, 'checklist-item-danger': !_vm.mazlicek.jmeno.valid, 'active-item': _vm.mazlicek.step.current === 1
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'jmenomazlicka'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Jméno mazlíčka")]), _vm._v(" "), (_vm.mazlicek.jmeno.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm.mazlicek.jmeno.value))]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.step.current >= 2, 'active-item': _vm.mazlicek.step.current === 2
    }
  }, [(_vm.mazlicek.step.current >= 2) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'rasa'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Plemeno")]), _vm._v(" "), (_vm.mazlicek.rasa.typ === 'app_rasa') ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.mazlicek.rasa.autocomplete.keyword) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.mazlicek.rasa.typ === 'app_velikost' && _vm.velikost && _vm.velikost.title) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.velikost.title) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.mazlicek.rasa.typ && (_vm.mazlicek.rasa.typ === 'app_velikost' && _vm.velikost && _vm.velikost.title)) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")]) : _vm._e()]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Plemeno")]), _vm._v(" "), (_vm.mazlicek.rasa.typ === 'app_rasa') ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.mazlicek.rasa.autocomplete.keyword) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.mazlicek.rasa.typ === 'app_velikost' && _vm.velikost && _vm.velikost.title) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.velikost.title) + "\n                    ")]) : _vm._e(), _vm._v(" "), (!_vm.mazlicek.rasa.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")]) : _vm._e()])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.narozeniny.valid, 'checklist-item-danger': !_vm.mazlicek.narozeniny.valid, 'active-item': _vm.mazlicek.step.current === 3
    }
  }, [(_vm.mazlicek.step.current >= 3) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'narozeniny'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Narozeniny")]), _vm._v(" "), (_vm.mazlicek.narozeniny.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm.formatDatumNarozeni))]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Narozeniny")]), _vm._v(" "), (_vm.mazlicek.narozeniny.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm.formatDatumNarozeni))]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.pohlavi.valid, 'checklist-item-danger': !_vm.mazlicek.pohlavi.valid, 'active-item': _vm.mazlicek.step.current === 4
    }
  }, [(_vm.mazlicek.step.current >= 4) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'pohlavi'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Pohlaví")]), _vm._v(" "), (_vm.mazlicek.pohlavi.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm.mazlicek.pohlavi.value.charAt(0).toUpperCase() + _vm.mazlicek.pohlavi.value.slice(1)))]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Pohlaví")]), _vm._v(" "), (_vm.mazlicek.pohlavi.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm.mazlicek.pohlavi.value))]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.hmotnostkondice.valid, 'checklist-item-danger': !_vm.mazlicek.hmotnostkondice.valid, 'active-item': _vm.mazlicek.step.current === 5
    }
  }, [(_vm.mazlicek.step.current >= 5) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'hmotnostkondice'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Hmotnost a kondice")]), _vm._v(" "), (_vm.mazlicek.hmotnostkondice.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.kondiceValue) + "\n")]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Hmotnost a kondice")]), _vm._v(" "), (_vm.mazlicek.hmotnostkondice.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("\n                        " + _vm._s(_vm.kondiceValue) + "\n                    ")]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.pohyb.valid || _vm.mazlicek.jeStene, 'checklist-item-danger': !_vm.mazlicek.pohyb.valid && !_vm.mazlicek.jeStene, 'active-item': _vm.mazlicek.step.current === 6
    }
  }, [(_vm.mazlicek.step.current >= 6) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'pohyb'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Aktivita")]), _vm._v(" "), _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm.aktivitaValue))])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Aktivita")]), _vm._v(" "), _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v(_vm._s(_vm.aktivitaValue))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.alergie.valid, 'checklist-item-danger': !_vm.mazlicek.alergie.valid, 'active-item': _vm.mazlicek.step.current === 7
    }
  }, [(_vm.mazlicek.step.current >= 7) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'alergie'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Zvýšená citlivost")]), _vm._v(" "), (_vm.mazlicek.alergie.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [(_vm.mazlicek.alergie.alergie) ? _c('span', [_vm._v("Ano")]) : _c('span', [_vm._v("Ne")])]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Zvýšená citlivost")]), _vm._v(" "), (_vm.mazlicek.alergie.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [(_vm.mazlicek.alergie.alergie) ? _c('span', [_vm._v("Ano")]) : _c('span', [_vm._v("Ne")])]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "checklist-item",
    class: {
      'checklist-item-success': _vm.mazlicek.suroviny.valid, 'checklist-item-danger': !_vm.mazlicek.suroviny.valid, 'active-item': _vm.mazlicek.step.current === 8
    }
  }, [(_vm.mazlicek.step.current >= 8) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'suroviny'
      }
    }
  }, [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Složení")]), _vm._v(" "), (_vm.mazlicek.suroviny.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [(_vm.mazlicek.suroviny.valid && _vm.slozkaItems && _vm.slozkaItems[0]) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.slozkaItems[0].title))])]) : _vm._e()]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")])]) : _c('span', [_c('div', {
    staticClass: "checklist-label"
  }, [_vm._v("Složení")]), _vm._v(" "), (_vm.mazlicek.suroviny.valid) ? _c('div', {
    staticClass: "checklist-value"
  }, [(_vm.mazlicek.suroviny.valid && _vm.slozkaItems && _vm.slozkaItems[0]) ? _c('span', [_c('span', [_vm._v(_vm._s(_vm.slozkaItems[0].title))])]) : _vm._e()]) : _c('div', {
    staticClass: "checklist-value"
  }, [_vm._v("Nevyplněno")])])], 1)]), _vm._v(" "), (_vm.lastStep) ? _c('div', {
    staticClass: "objednavka-btn"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.objednatBtn()
      }
    }
  }, [_vm._v("Přejít k objednávce")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bdae4d0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checklist.vue
// module id = 570
// module chunks = 1